import React from 'react';

// tslint:disable:max-line-length
const DismissIcon = (props) => (
  <svg width={1920} height={1920} viewBox="0 0 1920 1920" {...props}>
    <g fill={props.color || 'currentColor'} fillRule="nonzero">
      <path d="M1638.829 1469.123c46.86 46.86 46.854 122.84-.006 169.7-46.863 46.862-122.85 46.856-169.7.006L281.171 450.877c-46.86-46.86-46.854-122.84.006-169.7 46.863-46.862 122.85-46.856 169.7-.006l1187.952 1187.952z" />
      <path d="M1469.123 281.171c46.86-46.86 122.84-46.854 169.7.006 46.862 46.863 46.856 122.85.006 169.7L450.877 1638.829c-46.86 46.86-122.84 46.854-169.7-.006-46.862-46.863-46.856-122.85-.006-169.7L1469.123 281.171z" />
    </g>
  </svg>
);
// tslint:enable:max-line-length

export default DismissIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/DismissIcon.js